<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      show: true,
    };
  },
};
</script>

<style lang="scss" scoped></style>

<style scoped></style>
